import {SampleDetails} from 'constants/SampleConstants';

export default function makeEmptySampleDetails(): SampleDetails {
  return {
    batchInfo: null,
    bioentityInfo: null,
    boxInfo: null,
    containerInfo: null,
    plateInfo: null,
    textInfo: null,
    error: undefined,
    numberInfo: null,
    booleanInfo: null,
  };
}
